import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/app/store";
import { formatNumberWithCommas } from "../../../../helpers";

interface ViewKYCSettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ViewKYCSettingsModal: React.FC<ViewKYCSettingsModalProps> = ({
  isOpen,
  onClose,
}) => {
  const kycData = useSelector((state: RootState) => state.settings.kyc);

  if (!isOpen || !kycData?.length) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-2xl max-h-[90%] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">KYC Settings</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-600 text-2xl"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4 text-sm text-gray-700">
          {kycData.map((item: any) => (
            <div
              key={item.id}
              className="border border-gray-200 rounded-lg p-4 shadow-sm bg-gray-50"
            >
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <strong>ID: </strong> {item.id}
                </div>
                <div>
                  <strong>Status: </strong> {item.status}
                </div>
                <div>
                  <strong>KYC Status: </strong> {item.kycStatus}
                </div>
                <div>
                  <strong>KYC Fee: </strong> ₦
                  {formatNumberWithCommas(item.kycFee)}
                </div>
                <div>
                  <strong>Value Cap: </strong> ₦
                  {formatNumberWithCommas(item.valueCap)}
                </div>
                <div>
                  <strong>Daily Withdrawal Limit: </strong> ₦
                  {formatNumberWithCommas(item.dailyWithdrawalLimit)}
                </div>
                <div>
                  <strong>Monthly Withdrawal Limit: </strong> ₦
                  {formatNumberWithCommas(item.monthlyWithdrawalLimit)}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className="bg-primary text-white px-4 py-2 rounded-full hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewKYCSettingsModal;
